webpackJsonp([70144966829960],{

/***/ 254:
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	exports.__esModule = true;
	
	var _extends2 = __webpack_require__(27);
	
	var _extends3 = _interopRequireDefault(_extends2);
	
	var _classCallCheck2 = __webpack_require__(2);
	
	var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);
	
	var _possibleConstructorReturn2 = __webpack_require__(4);
	
	var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);
	
	var _inherits2 = __webpack_require__(3);
	
	var _inherits3 = _interopRequireDefault(_inherits2);
	
	var _keys = __webpack_require__(151);
	
	var _keys2 = _interopRequireDefault(_keys);
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function encode(data) {
	  return (0, _keys2.default)(data).map(function (key) {
	    return encodeURIComponent(key) + "=" + encodeURIComponent(data[key]);
	  }).join("&");
	}
	
	var Form = function (_Component) {
	  (0, _inherits3.default)(Form, _Component);
	
	  function Form(props) {
	    (0, _classCallCheck3.default)(this, Form);
	
	    var _this = (0, _possibleConstructorReturn3.default)(this, _Component.call(this, props));
	
	    _this.handleChange = function (e) {
	      var _this$setState;
	
	      _this.setState((_this$setState = {}, _this$setState[e.target.name] = e.target.value, _this$setState));
	    };
	
	    _this.handleSubmit = function (e) {
	      fetch('/', {
	        method: 'POST',
	        headers: { 'Content-Type': 'application/x-www-form-urlencoded' },
	        body: encode((0, _extends3.default)({ 'form-name': 'contact' }, _this.state))
	      }).then(function () {
	        return alert('Success!');
	      }).catch(function (error) {
	        return alert(error);
	      });
	
	      e.preventDefault();
	    };
	
	    _this.state = {};
	    return _this;
	  }
	
	  Form.prototype.render = function render() {
	    return _react2.default.createElement(
	      "div",
	      null,
	      _react2.default.createElement(
	        "form",
	        {
	          id: "contactForm",
	          className: "container form__margin-top gridish-container--complete gridish-grid",
	          name: "contact",
	          method: "post",
	          action: "/thanks/",
	          "data-netlify": "true",
	          "data-netlify-honeypot": "bot-field",
	          onSubmit: this.handleSubmit
	        },
	        _react2.default.createElement("input", { type: "hidden", name: "form-name", value: "contact" }),
	        _react2.default.createElement(
	          "p",
	          { hidden: true },
	          _react2.default.createElement(
	            "label",
	            null,
	            "Don\u2019t fill this out: ",
	            _react2.default.createElement("input", { name: "bot-field" })
	          )
	        ),
	        _react2.default.createElement(
	          "label",
	          { className: 'flex-align-items-baseline flex-justify-between form-element__margin-bottom gridish-grid' },
	          _react2.default.createElement(
	            "p",
	            { className: 'form-element__label gridish-grid__col--small--2 gridish-grid__col--xsmall--4' },
	            _react2.default.createElement(
	              "strong",
	              null,
	              "Full Name",
	              _react2.default.createElement(
	                "span",
	                { className: 'form-element__label__red' },
	                " *"
	              )
	            )
	          ),
	          _react2.default.createElement(
	            "div",
	            { className: 'form-element__margin-top form-text_input__field gridish-grid__col--small--5 gridish-grid__col--xsmall--4' },
	            _react2.default.createElement("input", {
	              type: "text",
	              name: "name",
	              required: true,
	              onChange: this.handleChange,
	              placeholder: "Your Name",
	              className: 'form-text_input__text'
	            })
	          )
	        ),
	        _react2.default.createElement(
	          "label",
	          { className: 'flex-align-items-baseline flex-justify-between form-element__margin-bottom gridish-grid' },
	          _react2.default.createElement(
	            "p",
	            { className: 'form-element__label gridish-grid__col--small--2 gridish-grid__col--xsmall--4' },
	            _react2.default.createElement(
	              "strong",
	              null,
	              "Email Address",
	              _react2.default.createElement(
	                "span",
	                { className: 'form-element__label__red' },
	                " *"
	              )
	            )
	          ),
	          _react2.default.createElement(
	            "div",
	            { className: 'form-element__margin-top form-text_input__field gridish-grid__col--small--5 gridish-grid__col--xsmall--4' },
	            _react2.default.createElement("input", {
	              type: "email",
	              name: "email",
	              required: true,
	              onChange: this.handleChange,
	              placeholder: "Your Email",
	              className: 'form-text_input__text'
	            })
	          )
	        ),
	        _react2.default.createElement(
	          "label",
	          { className: 'form-element__message__padding-top flex-justify-between form-element__margin-bottom gridish-grid' },
	          _react2.default.createElement(
	            "p",
	            { className: 'form-element__label gridish-grid__col--small--2 gridish-grid__col--xsmall--4' },
	            _react2.default.createElement(
	              "strong",
	              null,
	              "Message",
	              _react2.default.createElement(
	                "span",
	                { className: 'form-element__label__red' },
	                " *"
	              )
	            )
	          ),
	          _react2.default.createElement(
	            "div",
	            { className: 'form-element__margin-top form-text_input__field gridish-grid__col--small--5 gridish-grid__col--xsmall--4' },
	            _react2.default.createElement("textarea", {
	              name: "message",
	              required: true,
	              onChange: this.handleChange,
	              placeholder: "Give us a piece of your mind...",
	              className: 'form-text_input__text',
	              rows: "4"
	            })
	          )
	        ),
	        _react2.default.createElement("div", { "data-netlify-recaptcha": true }),
	        _react2.default.createElement(
	          "div",
	          { className: "gridish-container--complete form-actionButton" },
	          _react2.default.createElement(
	            "button",
	            {
	              type: "submit",
	              className: "form-actionButton__text"
	            },
	            "send message"
	          )
	        )
	      )
	    );
	  };
	
	  return Form;
	}(_react.Component);
	
	exports.default = Form;
	module.exports = exports["default"];

/***/ }),

/***/ 255:
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _classCallCheck2 = __webpack_require__(2);
	
	var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);
	
	var _possibleConstructorReturn2 = __webpack_require__(4);
	
	var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);
	
	var _inherits2 = __webpack_require__(3);
	
	var _inherits3 = _interopRequireDefault(_inherits2);
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _Form = __webpack_require__(254);
	
	var _Form2 = _interopRequireDefault(_Form);
	
	var _index = __webpack_require__(44);
	
	var _index2 = _interopRequireDefault(_index);
	
	var _classnames = __webpack_require__(6);
	
	var _classnames2 = _interopRequireDefault(_classnames);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var Contact = function (_React$Component) {
	  (0, _inherits3.default)(Contact, _React$Component);
	
	  function Contact() {
	    (0, _classCallCheck3.default)(this, Contact);
	    return (0, _possibleConstructorReturn3.default)(this, _React$Component.apply(this, arguments));
	  }
	
	  Contact.prototype.render = function render() {
	    return _react2.default.createElement(
	      'div',
	      { className: (0, _classnames2.default)() },
	      _react2.default.createElement(_index2.default, { pageName: 'contact' }),
	      _react2.default.createElement(
	        'h3',
	        { className: (0, _classnames2.default)('container gridish-container gridish-container--complete')
	        },
	        'Get in touch with us!'
	      ),
	      _react2.default.createElement(_Form2.default, null)
	    );
	  };
	
	  return Contact;
	}(_react2.default.Component);
	
	exports.default = Contact;
	module.exports = exports['default'];

/***/ }),

/***/ 289:
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _classCallCheck2 = __webpack_require__(2);
	
	var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);
	
	var _possibleConstructorReturn2 = __webpack_require__(4);
	
	var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);
	
	var _inherits2 = __webpack_require__(3);
	
	var _inherits3 = _interopRequireDefault(_inherits2);
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _Contact = __webpack_require__(255);
	
	var _Contact2 = _interopRequireDefault(_Contact);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var ContactPage = function (_React$Component) {
	  (0, _inherits3.default)(ContactPage, _React$Component);
	
	  function ContactPage(props) {
	    (0, _classCallCheck3.default)(this, ContactPage);
	
	    var _this = (0, _possibleConstructorReturn3.default)(this, _React$Component.call(this, props));
	
	    _this.state = {};
	    return _this;
	  }
	
	  ContactPage.prototype.render = function render() {
	    return _react2.default.createElement(
	      'div',
	      null,
	      _react2.default.createElement(_Contact2.default, null)
	    );
	  };
	
	  return ContactPage;
	}(_react2.default.Component);
	
	exports.default = ContactPage;
	module.exports = exports['default'];

/***/ })

});


// WEBPACK FOOTER //
// component---src-pages-contact-js-8c5383731ff842ab2038.js